export default __webpack_public_path__ + "static/media/settings.bad123dc.png";